import * as _ from "lodash";

import { Node } from "../Node";
import { _toThreeComplex, _toThreeValuePromise, AbstractProperty } from "./AbstractProperty";
import { json, MetadataRow } from "../../global";
import * as Commons from "oc-commons/Commons";
import { PVector2 } from "./PVector2";

export class PVector2Array extends PVector2 {
  default: [number, number];
  dimensionLabels: string[];

  constructor(args) {
    super({
      type: "Number[2]",
      dimensionLabels: ["min", "max"],
      ...args,
    });
  }

  toThree(instance: any) {
    return instance;
  }

  threeToInternalFormat(value: any): string {
    return value;
  }

  fromMetadataRow(metadataRow: MetadataRow): this {
    this.set(metadataRow[this.name]);
    return this;
  }

  toMetadataRow(metadataRow: MetadataRow): this {
    metadataRow[this.name] = this.get();
    return this;
  }
}
